var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-welcome-screen",
    },
    [
      _c("courseware-companion-box", {
        attrs: {
          msgCompanion: this.$gettext(
            "Es wurden bisher noch keine Inhalte eingepflegt."
          ),
        },
        scopedSlots: _vm._u([
          {
            key: "companionActions",
            fn: function fn() {
              return [
                _vm.canEdit && _vm.noContainers
                  ? _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: _vm.addContainer,
                        },
                      },
                      [_c("translate", [_vm._v("Einen Abschnitt hinzufügen")])],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canEdit && !_vm.noContainers && !_vm.editMode
                  ? _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: _vm.switchToEditView,
                        },
                      },
                      [_c("translate", [_vm._v("Seite bearbeiten")])],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }